import React from "react";
import { useBnbSelector } from "../../../../redux/store";
import { useBnbOptionalLabel } from "../../../../utils/labels";
import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/PriceFootNote";
import { showAemPriceExclVAT } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { showBnbMonthlyRates } from "../../../../utils/settings/bnbFinanceSettingUtils";

const PriceFootNote = (): JSX.Element | null => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const modelCode = useBnbSelector((state) => state.car.model.internalCode);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const step = useBnbSelector((state) => state.navigation.step);

    const footNoteLabel = useBnbOptionalLabel("priceFootNote");
    const footNoteExclVatLabel = useBnbOptionalLabel("priceFootNoteExcludingVat");

    if (financeOption === "cash") {
        if (footNoteExclVatLabel && showAemPriceExclVAT(commonSettings, AemFmComponent.Build, "new", modelCode)) {
            return <Styles.Text>{footNoteExclVatLabel}</Styles.Text>;
        } else if (footNoteLabel) {
            return <Styles.Text>{footNoteLabel}</Styles.Text>;
        }
    }
    if (
        financeOption === "monthly" &&
        showBnbMonthlyRates(commonSettings, bnbSettings, modelCode, step) &&
        bnbSettings.showMonthlyRateDisclaimerInline &&
        financeInfo.disclaimer
    ) {
        return <Styles.Text dangerouslySetInnerHTML={{ __html: financeInfo.disclaimer.value }} />;
    }

    return null;
};

export default PriceFootNote;
